import { Input, InputProps } from "antd";
import { FC } from "react";
import useReadonly from "src/hook/useReadonly";

/**
 * AntD Input which is disabled when user is readonly
 * @param props AntD Input properties
 * @param ignoreReadonly optional disable of readonly behavior
 * @returns
 */
export const XmInput: FC<InputProps & { ignoreReadonly?: boolean }> = ({ ignoreReadonly, disabled, ...props }) => {
  const { isDisabled } = useReadonly(ignoreReadonly, disabled)

  return (
    <Input
      {...props}
      disabled={isDisabled}
    />
  )
}